// 프로젝트 상태별 색상 정의
export const statusColors = {
  received: {
    primary: 'bg-gray-500',
    light: 'bg-gray-50',
    medium: 'bg-gray-100',
    text: 'text-gray-700',
    textLight: 'text-gray-800',
    textOnPrimary: 'text-white',
    border: 'border-gray-300',
    gradient: 'from-gray-400 to-gray-500',
    icon: 'text-gray-600',
    hex: '#6b7280'
  },
  review: {
    primary: 'bg-blue-500',
    light: 'bg-blue-50',
    medium: 'bg-blue-100',
    text: 'text-blue-700',
    textLight: 'text-blue-800',
    textOnPrimary: 'text-white',
    border: 'border-blue-300',
    gradient: 'from-blue-400 to-blue-600',
    icon: 'text-blue-600',
    hex: '#3b82f6'
  },
  contract: {
    primary: 'bg-purple-500',
    light: 'bg-purple-50',
    medium: 'bg-purple-100',
    text: 'text-purple-700',
    textLight: 'text-purple-800',
    textOnPrimary: 'text-white',
    border: 'border-purple-300',
    gradient: 'from-purple-400 to-purple-600',
    icon: 'text-purple-600',
    hex: '#a855f7'
  },
  completed: {
    primary: 'bg-green-500',
    light: 'bg-green-50',
    medium: 'bg-green-100',
    text: 'text-green-700',
    textLight: 'text-green-800',
    textOnPrimary: 'text-white',
    border: 'border-green-300',
    gradient: 'from-green-400 to-green-600',
    icon: 'text-green-600',
    hex: '#22c55e'
  },
  cancelled: {
    primary: 'bg-red-500',
    light: 'bg-red-50',
    medium: 'bg-red-100',
    text: 'text-red-700',
    textLight: 'text-red-800',
    textOnPrimary: 'text-white',
    border: 'border-red-300',
    gradient: 'from-red-400 to-red-600',
    icon: 'text-red-600',
    hex: '#ef4444'
  }
};

// 상태별 라벨
export const statusLabels = {
  received: '접수',
  review: '검토',
  contract: '계약',
  completed: '완료',
  cancelled: '취소'
};

// 용도별 스타일 반환 함수
export const getStatusStyle = (status, variant = 'primary') => {
  const colors = statusColors[status];
  if (!colors) return '';
  
  switch (variant) {
    case 'primary':
      // 뷰 페이지, 중요한 표시
      return `${colors.primary} ${colors.textOnPrimary}`;
    
    case 'light':
      // 리스트 카드 배지
      return `${colors.light} ${colors.text} ${colors.border} border`;
    
    case 'medium':
      // 필터 버튼, 테이블 배지
      return `${colors.medium} ${colors.textLight}`;
    
    case 'gradient':
      // 특별한 강조 효과
      return `bg-gradient-to-r ${colors.gradient} ${colors.textOnPrimary}`;
    
    case 'badge':
      // 작은 배지용
      return `${colors.light} ${colors.text}`;
      
    default:
      return `${colors.primary} ${colors.textOnPrimary}`;
  }
};

// 개별 색상 속성 가져오기
export const getStatusColor = (status, property = 'primary') => {
  const colors = statusColors[status];
  if (!colors) return '';
  return colors[property] || '';
};